import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'lib/hooks/redux';
import { setIsSideMenuCollapsed } from 'features/vicinityMapSlice';
import { useVicinityMapQuery } from 'lib/hooks/queries';
import styled from 'styled-components';

const CollapseButton = () => {
  const dispatch = useAppDispatch();
  const { isSideMenuCollapsed, showStaticMap } = useAppSelector((state) => ({
    isSideMenuCollapsed: state.vicinityMap.isSideMenuCollapsed,
    showStaticMap: state.vicinityMap.showStaticMap,
  }));

  const vicinityMapData = useVicinityMapQuery().data!;

  return (
    <StyledCollapseButton
      id="collapse-button"
      className="cy-collapse-button"
      onClick={() =>
        !showStaticMap ? dispatch(setIsSideMenuCollapsed(!isSideMenuCollapsed)) : null
      }
      data-cy="collapse-button"
    >
      {(isSideMenuCollapsed && vicinityMapData.main.sideMenuPosition === 'right') ||
      (!isSideMenuCollapsed &&
        (vicinityMapData.main.sideMenuPosition === 'left' ||
          !vicinityMapData.main.sideMenuPosition)) ? (
        <DoubleLeftOutlined />
      ) : (
        <DoubleRightOutlined />
      )}
    </StyledCollapseButton>
  );
};

export default CollapseButton;

const StyledCollapseButton = styled.button`
  position: absolute;
  top: 11%;
  ${({ theme }) => (theme.layout.sideMenuPosition === 'left' ? 'right: -31px' : 'left: -31px')};
  width: 32px;
  height: 32px;
  font-size: 16px;
  color: ${({ theme }) =>
    theme.layout.isSideMenuCollapsed ? theme.colors.primaryTextColor : theme.colors.primaryColor};
  background-color: ${({ theme }) =>
    theme.layout.isSideMenuCollapsed
      ? theme.colors.primaryColor
      : theme.colors.sideMenuBackgroundColor};
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  z-index: 1000;

  &:hover {
    color: ${({ theme }) =>
      theme.layout.isSideMenuCollapsed ? theme.colors.primaryColor : theme.colors.primaryTextColor};
    background-color: ${({ theme }) =>
      theme.layout.isSideMenuCollapsed ? theme.colors.primaryTextColor : theme.colors.primaryColor};
  }

  &:active {
    outline: none;
  }
`;
